import { CUSTOM_ATTRIBUTES_DATA_MAP_KEY_NAME } from "models/generateCustomAttributesSchema";

export function buildDraftAuditFormResetData(data: any) {
  if (!data) {
    return {};
  }

  return {
    ...data,
    ...(data[CUSTOM_ATTRIBUTES_DATA_MAP_KEY_NAME] || {}),
  };
}

export interface ExtractedContactDetails {
  phone?: string;
  email?: string;
  role?: string;
}

const NO_INFORMATION = "No Information";

const normalizeField = (value?: string): string | undefined =>
  value && value !== NO_INFORMATION ? value : undefined;

/**
 * Parses the scan-extracted contacts JSON and returns a lookup keyed by
 * lower-cased contact name. "No Information" sentinels are filtered out so
 * downstream callers can rely on truthy checks.
 */
export function buildExtractedContactDetailsByName(
  rawContacts: unknown,
): Map<string, ExtractedContactDetails> {
  const map = new Map<string, ExtractedContactDetails>();
  if (!rawContacts) {
    return map;
  }

  let parsed: any;
  try {
    parsed =
      typeof rawContacts === "string" ? JSON.parse(rawContacts) : rawContacts;
  } catch {
    return map;
  }

  if (!Array.isArray(parsed)) {
    return map;
  }

  for (const contact of parsed) {
    if (!contact?.name) continue;
    map.set(String(contact.name).toLowerCase(), {
      phone: normalizeField(contact.phone),
      email: normalizeField(contact.email),
      role: normalizeField(contact.role),
    });
  }
  return map;
}
